export default __webpack_public_path__ + "assets/img/ic-close-black.9c70dc5366360303144ea22dc0078267.svg";